import React, { useState, useEffect } from "react";
import moment from "moment";
import Approve from "../../Assets/approve-icon.png";
import Delete from "../../Assets/delete_icon.png";
import { aspekQcdsm } from "../../util/constant";
import { generateQRWithLogo } from "../../components/generateQrLogo/qr";
import { hasRole } from "../../util/utilFunction";
import "./SuggestionHistory.css";

// Checklist + komentar leader
const LEADER_ROLES = [
  "super_user",
  "produksi_leader",
  "qc_admin",
  "ppic_admin",
  "sp_admin",
  "pr_admin",
  "mesin_admin",
  "mold_admin",
  "warehouse_admin",
  "hrd_admin",
  "produksi_admin",
];
// Tombol approve (produksi_admin sengaja tidak ada di sini, sama seperti kode lama)
const APPROVE_ROLES = [
  "super_user",
  "hrd_admin",
  "produksi_leader",
  "warehouse_admin",
  "ppic_admin",
  "qc_admin",
  "mesin_admin",
  "mold_admin",
  "sp_admin",
  "pr_admin",
];
// Komentar penilai
const PENILAI_ROLES = ["hrd_admin", "super_user", "produksi_admin"];

export default function SuggestionHistory({
  images,
  role,
  handleChangeChecklist,
  handleKirimLeader,
  handleDelete,
  handleChangeKomentar,
  handleChangeQcdsm,
  handleChangeKategori,
  style,
  cariNama,
  isGantiSubMenuRiwayat,
}) {
  const [openIndex, setOpenIndex] = useState(null);
  const [qrApproverPembuat, setQrApproverPembuat] = useState({});
  const [qrApproverLeader, setQrApproverLeader] = useState({});
  const [qrApproverPenilai, setQrApproverPenilai] = useState({});
  const [visibleCount, setVisibleCount] = useState(30);

  const komentarPenilaiRef = React.useRef({});
  const komentarLeaderRef = React.useRef({});

  // ---------- Hak akses ----------
  const isLeader = hasRole(role, ...LEADER_ROLES);
  const canApprove = hasRole(role, ...APPROVE_ROLES);
  const canNilai = hasRole(role, ...PENILAI_ROLES);
  const isSuper = hasRole(role, "super_user");

  useEffect(() => {
    const penilai = {};
    const leader = {};

    images?.forEach((item) => {
      penilai[item.formId] = item.komentarPenilai || "";
      leader[item.formId] = item.komentarLeader || "";
    });

    komentarPenilaiRef.current = penilai;
    komentarLeaderRef.current = leader;
  }, [images]);

  useEffect(() => {
    setOpenIndex(null);
  }, [isGantiSubMenuRiwayat]);

  const findById = (category, id) => {
    return aspekQcdsm[category]?.find((item) => item.id === id) || null;
  };

  const renderKeterangan = (category, item) => {
    if (!item) return "-";

    const value = item[category];
    if (!value) return "-";

    const data = findById(category, Number(value));
    return data?.keterangan || "-";
  };

  useEffect(() => {
    async function createQR() {
      if (!images || images.length === 0) return;

      const pembuatQR = { ...qrApproverPembuat };
      const leaderQR = { ...qrApproverLeader };
      const penilaiQR = { ...qrApproverPenilai };

      for (const item of images.slice(0, visibleCount)) {
        const key = String(item.formId).trim();

        if (pembuatQR[key] && leaderQR[key] && penilaiQR[key]) continue;

        const pembuatText = item.name
          ? `${item.name}, ${moment(item.timestamp)
              .utcOffset("+0700")
              .format("DD-MM-YYYY HH:mm:ss")}`
          : "";

        const leaderText =
          item.approverKepala && item.checklistTimestamp
            ? `${item.approverKepala}, ${moment(item.checklistTimestamp)
                .utcOffset("+0700")
                .format("DD-MM-YYYY HH:mm:ss")}`
            : "";

        const penilaiText =
          item.penilai && item.timestampPenilai
            ? `${item.penilai}, ${moment(item.timestampPenilai)
                .utcOffset("+0700")
                .format("DD-MM-YYYY HH:mm:ss")}`
            : "";

        if (pembuatText && !pembuatQR[key]) {
          pembuatQR[key] = await generateQRWithLogo(pembuatText);
        }

        if (leaderText && !leaderQR[key]) {
          leaderQR[key] = await generateQRWithLogo(leaderText);
        }

        if (penilaiText && !penilaiQR[key]) {
          penilaiQR[key] = await generateQRWithLogo(penilaiText);
        }
      }

      setQrApproverPembuat(pembuatQR);
      setQrApproverLeader(leaderQR);
      setQrApproverPenilai(penilaiQR);
    }

    createQR();
  }, [visibleCount, images]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - 50 &&
        visibleCount < images.length
      ) {
        setVisibleCount((prev) => prev + 30);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [visibleCount, images]);

  useEffect(() => {
    setVisibleCount(30);
  }, [images]);

  return (
    <div
      style={
        !style
          ? {
              display: "flex",
              flexDirection: "column",
              gap: 10,
              padding: "0",
            }
          : style
      }
    >
      {images?.slice(0, visibleCount).map((item, index) => {
        const isOpen = openIndex === index;

        const key = String(item.formId).trim();

        const datePembuat = moment(item.timestamp).utcOffset(7);
        const datePenilai = moment(item.checklistTimestamp).utcOffset(7);
        const dateDisetujui = moment(item.timestampPenilai).utcOffset(7);

        return (
          <div
            key={item.formId || index}
            style={{
              border: "1px solid #ddd",
              borderRadius: 8,
              padding: 10,
              background: !item.isApprove
                ? "#FFB2B2"
                : item.checklistLeader === "Belum"
                ? "orange"
                : "white",
            }}
          >
            {/* HEADER */}
            <div
              onClick={() => setOpenIndex(isOpen ? null : index)}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <div style={{ fontSize: 12, flex: 2 }}>
                {moment(item.timestamp)
                  .utcOffset(7)
                  .format("DD-MM-YYYY, HH:mm:ss")}
              </div>

              <div style={{ fontSize: 12, flex: 2 }}>
                {item.name.split(" ").slice(0, 2).join(" ")}
              </div>

              <div style={{ fontSize: 12, fontWeight: "600", flex: 1 }}>
                {item.kepalaShift}
              </div>

              {item.kategori ? (
                <div style={{ fontSize: 12, flex: 1 }}>{item.kategori}</div>
              ) : (
                <div style={{ flex: 1 }} />
              )}

              <div style={{ flex: "0 0 auto" }}>▼</div>
            </div>

            {/* 🔥 ACCORDION (SELALU RENDER) */}
            <div className={`accordion-content-ss ${isOpen ? "active" : ""}`}>
              <div className="accordion-inner">
                <div className="wrapper-ide">
                  <div>
                    <p className="font-14-mobile">
                      <b>Ide Perbaikan :</b>
                    </p>
                    <p
                      className="margin-0 font-12-mobile"
                      style={{ wordBreak: "break-word" }}
                    >
                      {item.idePerbaikan}
                    </p>
                  </div>
                  <div>
                    <p className="margin-0 font-14-mobile">
                      <b>Tujuan Perbaikan :</b>
                    </p>
                    <p
                      className="font-12-mobile"
                      style={{ wordBreak: "break-word" }}
                    >
                      {item.tujuanPerbaikan}
                    </p>
                  </div>
                </div>
                <p
                  className="font-14-mobile"
                  style={{ wordBreak: "break-word", margin: 0 }}
                >
                  <b>Status :</b> {item.status} Dilakukan
                </p>
                <div style={{ display: "flex", gap: 10 }}>
                  <div>
                    <p className="font-14-mobile">
                      <b>Before</b>
                    </p>
                    <img
                      src={item.imageBefore}
                      style={{
                        width: "100%",
                        maxWidth: "130px",
                        borderRadius: 6,
                      }}
                    />
                  </div>
                  <div>
                    <p className="font-14-mobile">
                      <b>After</b>
                    </p>
                    <img
                      src={item.imageAfter}
                      style={{
                        width: "100%",
                        maxWidth: "130px",
                        borderRadius: 6,
                      }}
                    />
                  </div>
                </div>
                <br />
                {/* CHECKLIST */}
                {isLeader ? (
                  <>
                    {["Sudah", "Belum"].map((val) => (
                      <div
                        key={val}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 8,
                        }}
                        onChange={() =>
                          !cariNama && !item.isApprove
                            ? handleChangeChecklist(item.formId, val)
                            : ""
                        }
                      >
                        <label>
                          Ide Perbaikan <b>{val.toLowerCase()}</b> dilaksanakan
                        </label>
                        <input
                          type="checkbox"
                          checked={item.checklistLeader === val}
                          style={{ width: 18, height: 18 }}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {["Sudah", "Belum"].map((val) => (
                      <div
                        key={val}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 8,
                        }}
                      >
                        <label>
                          Ide Perbaikan <b>{val.toLowerCase()}</b> dilaksanakan
                        </label>
                        <input
                          type="checkbox"
                          checked={item.checklistLeader === val}
                          style={{ width: 18, height: 18 }}
                        />
                      </div>
                    ))}
                  </>
                )}
                {/* KOMENTAR LEADER */}
                <div>
                  <p className="font-14-mobile">
                    <b>Komentar Leader :</b>
                  </p>
                  {isLeader && !item.isApprove && !cariNama ? (
                    <textarea
                      defaultValue={item.komentarLeader || ""}
                      name="komentarLeader"
                      onChange={(e) => {
                        const upper = e.target.value.toUpperCase();

                        e.target.value = upper;
                        komentarLeaderRef.current[item.formId] = upper;
                      }}
                      onBlur={() =>
                        handleChangeKomentar(
                          item.formId,
                          {
                            target: {
                              name: "komentarLeader",
                              value:
                                komentarLeaderRef.current[item.formId] || "",
                            },
                          },
                          "Leader"
                        )
                      }
                      className="textarea-komentar-penilai"
                    />
                  ) : (
                    <p className="text-content">{item.komentarLeader}</p>
                  )}
                </div>

                <div>
                  <p
                    className="font-14-mobile"
                    style={{ fontWeight: "600", margin: "6px 0" }}
                  >
                    Kategori:
                  </p>
                  {!item.isPenilai && !cariNama && isSuper ? (
                    <select
                      name="kategori"
                      className="select-input-status-ss"
                      value={item.kategori || "Pilih Kategori"}
                      onChange={(e) => handleChangeKategori(item.formId, e)}
                    >
                      <option>Pilih Kategori</option>
                      <option value="SAFETY">SAFETY</option>
                      <option value="5R">5 R</option>
                    </select>
                  ) : (
                    <p>{item.kategori}</p>
                  )}
                </div>
                {/* Tinjauan Aspek Penilaian */}
                <p className="font-14-mobile" style={{ fontWeight: "600" }}>
                  Tinjauan Terhadap Aspek QCDSM :
                </p>
                <div className="wrapper-card-aspek">
                  <div className="wrapper-aspek-penilaian-ss">
                    <p
                      className="font-14-mobile"
                      style={{
                        margin: "0 0 6px 0",
                        fontWeight: "600",
                        textDecoration: "underline",
                      }}
                    >
                      Quality (Q)
                    </p>
                    <p className="keterangan-nilai-aspek font-12-mobile">
                      {renderKeterangan("q", item)}
                    </p>
                    <input
                      className="input-nilai-aspek"
                      type="number"
                      name="q"
                      value={item.q || ""}
                      onChange={(e) =>
                        !item.isPenilai && !cariNama
                          ? handleChangeQcdsm(item.formId, e)
                          : ""
                      }
                      disabled={!isSuper}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                  <div className="wrapper-aspek-penilaian-ss">
                    <p
                      className="font-14-mobile"
                      style={{
                        margin: "0 0 6px 0",
                        fontWeight: "600",
                        textDecoration: "underline",
                      }}
                    >
                      Cost (C)
                    </p>
                    <p className="keterangan-nilai-aspek font-12-mobile">
                      {renderKeterangan("c", item)}
                    </p>
                    <input
                      className="input-nilai-aspek"
                      type="number"
                      name="c"
                      value={item.c || ""}
                      onChange={(e) =>
                        !item.isPenilai && !cariNama
                          ? handleChangeQcdsm(item.formId, e)
                          : ""
                      }
                      disabled={!isSuper}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                  <div className="wrapper-aspek-penilaian-ss">
                    <p
                      className="font-14-mobile"
                      style={{
                        margin: "0 0 6px 0",
                        fontWeight: "600",
                        textDecoration: "underline",
                      }}
                    >
                      Delivery (D)
                    </p>
                    <p className="keterangan-nilai-aspek font-12-mobile">
                      {renderKeterangan("d", item)}
                    </p>
                    <input
                      className="input-nilai-aspek"
                      type="number"
                      name="d"
                      value={item.d || ""}
                      onChange={(e) =>
                        !item.isPenilai && !cariNama
                          ? handleChangeQcdsm(item.formId, e)
                          : ""
                      }
                      disabled={!isSuper}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                  <div className="wrapper-aspek-penilaian-ss">
                    <p
                      className="font-14-mobile"
                      style={{
                        margin: "0 0 6px 0",
                        fontWeight: "600",
                        textDecoration: "underline",
                      }}
                    >
                      Safety - K3
                    </p>
                    <p className="keterangan-nilai-aspek font-12-mobile">
                      {renderKeterangan("s_k3", item)}
                    </p>
                    <input
                      className="input-nilai-aspek"
                      type="number"
                      name="s_k3"
                      value={item.s_k3 || ""}
                      onChange={(e) =>
                        !item.isPenilai && !cariNama
                          ? handleChangeQcdsm(item.formId, e)
                          : ""
                      }
                      disabled={!isSuper}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>

                  {/* Safety - Lingkungan */}
                  <div className="wrapper-aspek-penilaian-ss">
                    <p
                      className="font-14-mobile"
                      style={{
                        margin: "0 0 6px 0",
                        fontWeight: "600",
                        textDecoration: "underline",
                      }}
                    >
                      Safety - Lingkungan
                    </p>
                    <p className="keterangan-nilai-aspek font-12-mobile">
                      {renderKeterangan("s_lingkungan", item)}
                    </p>
                    <input
                      className="input-nilai-aspek"
                      type="number"
                      name="s_lingkungan"
                      value={item.s_lingkungan || ""}
                      onChange={(e) =>
                        !item.isPenilai && !cariNama
                          ? handleChangeQcdsm(item.formId, e)
                          : ""
                      }
                      disabled={!isSuper}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                  <div className="wrapper-aspek-penilaian-ss">
                    <p
                      className="font-14-mobile"
                      style={{
                        margin: "0 0 6px 0",
                        fontWeight: "600",
                        textDecoration: "underline",
                      }}
                    >
                      Morale (M)
                    </p>
                    <p className="keterangan-nilai-aspek font-12-mobile">
                      {renderKeterangan("m", item)}
                    </p>
                    <input
                      className="input-nilai-aspek"
                      type="number"
                      name="m"
                      value={item.m || ""}
                      onChange={(e) =>
                        !item.isPenilai && !cariNama
                          ? handleChangeQcdsm(item.formId, e)
                          : ""
                      }
                      disabled={!isSuper}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                {/* KOMENTAR PENILAI */}
                <div>
                  <p className="font-14-mobile">
                    <b>Komentar Penilai :</b>
                  </p>
                  {!cariNama && !item.isPenilai && canNilai ? (
                    <textarea
                      defaultValue={item.komentarPenilai || ""}
                      name="komentarPenilai"
                      onChange={(e) => {
                        const upper = e.target.value.toUpperCase();

                        e.target.value = upper;

                        komentarPenilaiRef.current[item.formId] = upper;
                      }}
                      onBlur={() =>
                        handleChangeKomentar(
                          item.formId,
                          {
                            target: {
                              name: "komentarPenilai",
                              value:
                                komentarPenilaiRef.current[item.formId] || "",
                            },
                          },
                          "Penilai"
                        )
                      }
                      className="textarea-komentar-penilai"
                    />
                  ) : (
                    <p className="text-content">{item.komentarPenilai}</p>
                  )}
                </div>
                <br />
                <div className="wrapper-card-ttd-ss">
                  <div className="wrapper-ttd-ss">
                    <p
                      className="nama-tanggal-ttd-ss"
                      style={{ border: "none", lineHeight: "16px" }}
                    >
                      Dibuat
                    </p>
                    {qrApproverPembuat?.[key] && (
                      <img
                        src={qrApproverPembuat[key]}
                        style={{
                          width: 84,
                          height: 84,
                          borderTop: "1px solid black",
                        }}
                      />
                    )}

                    <p className="nama-tanggal-ttd-ss">
                      {item.name.split(" ").slice(0, 1).join(" ")}
                    </p>

                    {item.timestamp ? (
                      <p className="nama-tanggal-ttd-ss">
                        {datePembuat.format("DD-MM-YYYY")}
                        <br />
                        {datePembuat.format("HH:mm:ss")}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="wrapper-ttd-ss">
                    <p
                      className="nama-tanggal-ttd-ss"
                      style={{ border: "none", lineHeight: "16px" }}
                    >
                      Disetujui
                    </p>
                    {qrApproverLeader?.[key] && (
                      <img
                        src={qrApproverLeader[key]}
                        style={{
                          width: 84,
                          height: 84,
                          borderTop: "1px solid black",
                        }}
                      />
                    )}
                    {item.approverKepala ? (
                      <p className="nama-tanggal-ttd-ss">
                        {item.approverKepala.split(" ").slice(0, 1).join(" ")}
                      </p>
                    ) : (
                      ""
                    )}
                    {item.checklistTimestamp ? (
                      <p className="nama-tanggal-ttd-ss">
                        {datePenilai.format("DD-MM-YYYY")}
                        <br />
                        {datePenilai.format("HH:mm:ss")}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="wrapper-ttd-ss">
                    <p
                      className="nama-tanggal-ttd-ss"
                      style={{ border: "none", lineHeight: "16px" }}
                    >
                      Diterima
                    </p>
                    {qrApproverPenilai?.[key] && (
                      <img
                        src={qrApproverPenilai[key]}
                        style={{
                          width: 84,
                          height: 84,
                          borderTop: "1px solid black",
                        }}
                      />
                    )}
                    {item.penilai ? (
                      <p className="nama-tanggal-ttd-ss">
                        {item.penilai.split(" ").slice(0, 1).join(" ")}
                      </p>
                    ) : (
                      ""
                    )}
                    {item.timestampPenilai ? (
                      <p className="nama-tanggal-ttd-ss">
                        {dateDisetujui.format("DD-MM-YYYY")}
                        <br />
                        {dateDisetujui.format("HH:mm:ss")}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <br />
                {/* ACTION */}

                <div
                  style={{
                    display: "flex",
                    gap: 24,
                    justifyContent: "end",
                  }}
                >
                  {role.name === item.name && !item.isApprove ? (
                    <img
                      src={Delete}
                      style={{ width: 28, height: 28, cursor: "pointer" }}
                      onClick={() => handleDelete(item.formId)}
                    />
                  ) : (
                    ""
                  )}
                  {canApprove && !item.isApprove ? (
                    <img
                      src={Approve}
                      style={{ width: 28, height: 28, cursor: "pointer" }}
                      onClick={() => handleKirimLeader(item.formId)}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
